import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface CdcFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const CdcFilter = ({ value = [], onChange, t }: CdcFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_general_cdc")}
      type="cdc"
      value={value}
      onChange={onChange}
    />
  );
};
